// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__0XY36","animate":"modal_animate__tOZJq","content":"modal_content__6Fwac","fadeInSize":"modal_fadeInSize__1rEAg","fadeInColor":"modal_fadeInColor__U8wWm"};